module.exports = __webpack_public_path__ + "img/carousel6.9edfaf4a.jpg";